export enum GridColumnTemplateEnum {
	// Starting at 100, to avoid conflicts with legacy templates
	Default = 100,
	Boolean = 101,
	Date = 102,
	DateTime = 103,
	PhoneNumber = 104,
	LinkButton = 105,
	Button = 106,
	ZipCode = 107,
	Month = 108,
	PriceWoGrt = 109,
	Percentage,
}
